import { NgModule } from '@angular/core';
import {
  AuthorizationGroupsClient,
  BatchesClient,
  CompaniesClient,
  DashboardClient,
  ESVRsClient,
  FillSiteCleanFillUsersClient,
  FillSiteQualifiedPersonsClient,
  FillSitesClient,
  FillSiteSourceSitesClient,
  GroupClient,
  HaulersClient,
  LegalEntitiesClient,
  NotificationsClient,
  PolicyClient,
  QualifiedPersonInviteClient,
  QualifiedPersonsClient,
  SourceSiteCleanFillUsersClient,
  SourceSiteQualifiedPersonsClient,
  SourceSitesClient,
  TermsAndConditionsClient,
  TrucksClient,
  UserInviteClient,
  UsersClient
} from '@services/cleanfill-api/cleanfill-api.generated';

export const CLEANFILL_PROVIDERS = [
  CompaniesClient,
  BatchesClient,
  HaulersClient,
  TrucksClient,
  FillSitesClient,
  UsersClient,
  SourceSitesClient,
  QualifiedPersonsClient,
  QualifiedPersonInviteClient,
  ESVRsClient,
  LegalEntitiesClient,
  SourceSiteCleanFillUsersClient,
  FillSiteCleanFillUsersClient,
  FillSiteSourceSitesClient,
  SourceSiteQualifiedPersonsClient,
  FillSiteQualifiedPersonsClient,
  AuthorizationGroupsClient,
  GroupClient,
  PolicyClient,
  DashboardClient,
  UserInviteClient,
  NotificationsClient,
  TermsAndConditionsClient
];

@NgModule({
  providers: [...CLEANFILL_PROVIDERS]
})
export class CleanfillApiModule {}
